import {
  DateTimePicker,
  DateTimePickerProps,
} from "@mui/x-date-pickers/DateTimePicker";
import { PickersTextField } from "@mui/x-date-pickers/PickersTextField";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendar-icon.svg";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { MuiBox } from "../box/MuiBox";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiDateFieldWrapper } from "../dateField/MuiDateField.style";

export const OpenPickerIcon: React.FC = () => <CalendarIcon />;

export interface MuiDateTimeFieldProps
  extends DateTimePickerProps<Dayjs, boolean> {
  onChange?: (newValue: dayjs.Dayjs | null) => void;
  id?: string;
  label?: string;
  isMandatory?: boolean;
  disableLabel?: boolean;
  isErrorIconDateTimeEnabled?: boolean;
  valueFormat?: string;
  clearable?: boolean;
  placeholder?: string;
  requiredARIALabel?: string;
  selectDateTimeARIALabel?: string;
}

export const MuiDateTimeField: React.FC<MuiDateTimeFieldProps> = ({
  onChange,
  id = COMPONENT_IDS.COMMON_DATE_TIME_PICKER_FORM_CONTROLLER,
  label,
  isMandatory,
  disableLabel,
  isErrorIconDateTimeEnabled = true,
  clearable = false,
  placeholder = "",
  requiredARIALabel,
  selectDateTimeARIALabel,
  ...rest
}) => {
  return (
    <MuiDateFieldWrapper>
      {label && (
        <MuiBox className="title">
          <MuiTypography
            className={disableLabel ? "mui-label disabled" : "mui-label"}
            component="label"
            variant="h3"
          >
            {label}{" "}
            {isMandatory && (
              <label aria-label={requiredARIALabel} className="asterisk">
                *
              </label>
            )}
          </MuiTypography>
        </MuiBox>
      )}
      <DateTimePicker
        closeOnSelect={false}
        {...(placeholder && { label: placeholder })}
        onChange={onChange}
        enableAccessibleFieldDOMStructure
        slots={{
          textField: PickersTextField,
          openPickerIcon: OpenPickerIcon,
        }}
        slotProps={{
          field: {
            clearable,
          },
          textField: {
            id: id,
            inputProps: {
              "data-testid": id,
              "aria-label": selectDateTimeARIALabel,
            },
          },
        }}
        {...rest}
      />
    </MuiDateFieldWrapper>
  );
};
